import { compose, curry, map, prop, sortBy } from 'ramda'
import { useRef, useEffect } from 'react'

// TODO: Remove file after remove all usage of these helpers
// export const formatOptionsFromObject = obj => Object.keys(obj).map(key => ({ label: obj[key], value: key }))
// export const formatOptionsFromArray = array => array.map(value => ({ label: value, value }))

export const formatOptionsFromArrayWithTranslation = (array, t, prefix) =>
  array.map(value => ({ label: t((prefix || '') + value, value), value }))

export const formatWrappedOptionsFromCollection = curry((wrap, label, value, array) =>
  compose(
    sortBy(prop('label')),
    map(col => ({ key: col[label] + col[value], label: wrap(col[label]), value: col[value], origin: col }))
  )(array)
)

export const formatOptionsFromCollection = formatWrappedOptionsFromCollection(v => v)

export const useSelectResetKey = value => {
  const componentKey = useRef(1)
  const previousValueLength = useRef(0)

  useEffect(() => {
    if (previousValueLength.current > 0 && Array.isArray(value) && value.length === 0) {
      componentKey.current += 1
    }

    previousValueLength.current = Array.isArray(value) ? value.length : 0
  }, [value])

  const incrementKey = () => {
    componentKey.current += 1
    return componentKey.current
  }

  return {
    key: componentKey.current,
    incrementKey
  }
}

export const getEntityCountLabel = value => {
  if (!value) return ''
  if (!Array.isArray(value)) return value.name || ''

  if (value.length === 0) return ''
  if (value.length === 1) return value[0].name

  return `${value.length} itens selecionados`
}

export const formatSelectedLabel = value => {
  if (Array.isArray(value) && value.length === 1 && value[0]?.id === 'select-all') {
    return 'Todos os itens'
  }

  return getEntityCountLabel(value)
}
